<div class="settings-container page-shell">
  <mat-toolbar class="header">
    <span>{{ "menu.extension" | translate }}</span>
    <div class="header-buttons">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="saveExtensionSettings()"
        [disabled]="saving || !checkboxChanged || loading"
      >
        <mat-spinner
          *ngIf="saving"
          diameter="18"
          class="dc-btn-spinner"
        ></mat-spinner>
        <mat-icon *ngIf="!saving">save</mat-icon>
        <span>{{
          saving ? ("saving" | translate) : ("save" | translate)
        }}</span>
      </button>
    </div>
  </mat-toolbar>

  <div class="form">
    <div class="extensions-grid">
      <section class="form-section">
        <h3 class="section-title">Chrome Extension</h3>
        <p class="section-hint">
          {{ "extension.chromeIndividualDescription" | translate }}
        </p>
        <div class="ig-toolbar">
          <a
            mat-stroked-button
            href="https://chromewebstore.google.com/detail/gsignature-stopki-e-mail/hgemmbnchnegomnmpngehokoaendhpoe"
            target="_blank"
            rel="noopener"
          >
            <img
              src="https://fonts.gstatic.com/s/i/productlogos/chrome_store/v7/192px.svg"
              alt=""
              class="ig-logo"
            />
            {{ "extension.chromeDownloadButton" | translate }}
          </a>
        </div>
        <p class="section-hint">
          {{ "extension.chromeInfoDescription" | translate }}
        </p>

        <h4 class="ig-subtitle">
          {{ "extension.chromeWorkspaceTitle" | translate }}
        </h4>
        <p class="section-hint">
          {{ "extension.chromeWorkspaceDescription" | translate }}
        </p>
        <ol class="ig-prose">
          <li>
            {{ "extension.chromeStep1" | translate }}
            <a
              href="https://admin.google.com/ac/chrome/apps"
              target="_blank"
              rel="noopener"
              >{{ "extension.chromeAdminPanel" | translate }}</a
            >
          </li>
          <li [innerHTML]="'extension.chromeStep2' | translate"></li>
          <li [innerHTML]="'extension.chromeStep3' | translate"></li>
          <li>
            <span [innerHTML]="'extension.chromeStep4' | translate"></span>
            <div class="copy-box">
              <span class="copy-box-header">{{
                "extension.chromeExtensionId" | translate
              }}</span>
              <mat-icon (click)="copyToClipboard(extensionId)"
                >content_copy</mat-icon
              >
              <code>{{ extensionId }}</code>
            </div>
          </li>
          <li [innerHTML]="'extension.chromeStep5' | translate"></li>
        </ol>
      </section>

      <section class="form-section">
        <h3 class="section-title">Outlook Add-in</h3>
        <p class="section-hint">
          {{ "extension.outlookIndividualDescription" | translate }}
        </p>
        <div class="ig-toolbar">
          <a
            mat-stroked-button
            [href]="outlookMarketplaceUrl"
            target="_blank"
            rel="noopener"
          >
            <img src="assets/img/microsoft.svg" alt="" class="ig-logo" />
            {{ "extension.marketplaceLabel" | translate }}
          </a>
        </div>
        <p class="section-hint">
          {{ "extension.outlookInfoDescription" | translate }}
        </p>
        <ul class="ig-prose">
          <li>{{ "extension.outlookVersions.android" | translate }}</li>
          <li>{{ "extension.outlookVersions.ios" | translate }}</li>
          <li>{{ "extension.outlookVersions.web" | translate }}</li>
          <li>{{ "extension.outlookVersions.mac365" | translate }}</li>
          <li>{{ "extension.outlookVersions.windows365" | translate }}</li>
        </ul>

        <h4 class="ig-subtitle">
          {{ "extension.outlookWorkspaceTitle" | translate }}
        </h4>
        <p class="section-hint">
          {{ "extension.outlookWorkspaceDescription" | translate }}
        </p>
        <ol class="ig-prose">
          <li>
            {{ "extension.outlookStep1" | translate }}
            <a [href]="outlookMarketplaceUrl" target="_blank" rel="noopener">{{
              "extension.marketplaceLabel" | translate
            }}</a>
          </li>
          <li>{{ "extension.outlookStep2" | translate }}</li>
          <li>{{ "extension.outlookStep3" | translate }}</li>
          <li>{{ "extension.outlookStep4" | translate }}</li>
        </ol>
        <p class="section-hint">
          {{ "extension.outlookInstallationDelay" | translate }}
        </p>
      </section>
    </div>

    <section class="form-section">
      <h3 class="section-title">
        {{ "extension.settingsSection" | translate }}
      </h3>
      <div class="option-list">
        <mat-checkbox
          #domainRulesCheckbox
          color="primary"
          [(ngModel)]="domainRulesEnabled"
          (change)="toggleDomainRules(domainRulesEnabled)"
        >
          {{ "extension.enableDomainRules" | translate }}
        </mat-checkbox>
        <mat-checkbox
          #internalSignatureCheckbox
          color="primary"
          [(ngModel)]="internalSignatureEnabled"
          (change)="toggleInternalSignature(internalSignatureEnabled)"
        >
          {{ "extension.enableInternalSignature" | translate }}
        </mat-checkbox>
        <mat-checkbox
          color="primary"
          [(ngModel)]="lockSignatureEditingEnabled"
          (change)="toggleLockSignatureEditing(lockSignatureEditingEnabled)"
        >
          {{ "extension.lockSignatureEditing" | translate }}
        </mat-checkbox>
      </div>
    </section>
  </div>

  <div class="dbc1-loading dbc1-loading--overlay" *ngIf="loading">
    <app-loading></app-loading>
  </div>
</div>
